module.exports = __webpack_public_path__ + "img/electronic_use_selected.d9c2af3b.svg";